import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProviderCostEstimator } from '../../../core/model/v2/appointment/provider-cost-estimator';
import { FindCareTeamModel } from '../../../core/models/find-care/findcare-team-model';
import { MapLocation } from '../../../core/models/google-map-marker';
import { AppointmentsService } from '../../../core/services/v2/appointments.service';
import { UtilsService } from '../../../core/services/v2/utils.service';
import { WindowLoaderService } from '../window-loader/window-loader.service';

@Component({
  selector: 'app-physican-card',
  templateUrl: './physican-card.component.html',
  styleUrls: ['./physican-card.component.scss']
})
export class PhysicanCardComponent implements OnInit {
  @Input() physician: any;
  @Input() currentLocation: MapLocation;
  @Input() patientId: number;
  @Input() showDirection: boolean;
  @Input() zipCode: "";
  @Input() planId: "";
  @Input() planName: "";
  showDirectionMarker: boolean = false;  
 // insurancePlan: any;
  providerPricing: string;
  constructor(private router: Router, private utils: UtilsService, private loaderService: WindowLoaderService,
    private appointmentService: AppointmentsService) { }

  ngOnInit() {
    this.providerPricing="";
    if (this.currentLocation && this.currentLocation.lat && this.currentLocation.lng && this.showDirection) {
      this.showDirectionMarker = true;
    }
  }

  openDirection() {
    let url = `https://www.google.com/maps/dir/?api=1&origin=${this.currentLocation.lat},${this.currentLocation.lng}&destination=${this.physician.latitude},${this.physician.longitude}&travelmode=driving`
    window.open(url, "_blank");
  }

  openProviderPage() {
    if (this.physician.searchType == 'Physician' || this.physician.searchType == 'Medical Professional'
      || this.physician.npiType == "PRACTITIONER" || this.physician.npitype == "PRACTITIONER" || this.physician.npiType == "PHYSICIAN") {
      let dataToPass: any = {
        src: "summary",
        patientId: this.patientId ? this.patientId : null
      };
      if (this.physician.isInNetwork && this.physician.id && this.physician.id > 0) {
        dataToPass.id = this.physician.id;
      }
      else if (!this.physician.isInNetwork && (this.physician.npiNumber || this.physician.npi)) {
        dataToPass.npi = this.physician.npiNumber ? this.physician.npiNumber : this.physician.npi;
      }
      else if (this.physician.searchId && this.physician.searchId > 0) {
        dataToPass.id = this.physician.searchId;
      }
      this.router.navigate([
        "/patient/physician/profile",
        dataToPass
      ]);
    }
    else if (this.physician.searchType == 'HealthSystem' || this.physician.npiType == 'HEALTHSYSTEM') {
      if (this.physician.searchId) {
        this.router.navigate([`/practice/profile/profilelocation/${this.physician.searchId}`]);
      }
      else {
        this.utils.showMessageSnackBar('Health System is out of network.', true);
      }
    }
  }

  getProviderServiceCost() {
    //const zipCode = this.appt.practitioner && this.appt.practitioner.location ? this.appt.practitioner.location.zipCode : "";
    const providerCostEstimatorRequestObj: ProviderCostEstimator = {
      search_parameters: {
        npi_numbers: {
          professional_npi_numbers: [this.physician.npi ? +this.physician.npi : 0]
        },
        location: {
          zip_code: this.zipCode,// "75202", // Zip code for patient
          radius_in_miles: 50 //Hard coded
        }
      },
      plan_details: {
        plan_id: this.planId,//"942404110",  // Insurance Plan table PayerId
        plan_id_type: "EIN",  // Hard coded
        plan_name: this.planName//"NATIONAL-PPO" // Insurance Plan table name column
      },
      "service_details": [
        {
          billing_code_type: "CPT", // Hard coded
          billing_code: "99204" // Hard Coded for now
        }
      ]
    };
    this.loaderService.blockWithLoader(this.appointmentService.getProviderCostEstimation(providerCostEstimatorRequestObj)).subscribe(
      (res) => {
        if (res && res.estimates && res.estimates.length > 0 && res.estimates[0].total_combined_cost != undefined) {
          this.providerPricing = res.estimates[0].total_combined_cost.total_cost != undefined ? res.estimates[0].total_combined_cost.total_cost.human_readable : "$0";
        }
        else if (res.estimates[0].institutional_info.institutional_fee.total_cost.human_readable != undefined && res.estimates[0].institutional_info.institutional_fee.total_cost.human_readable != null) {
          this.providerPricing = res.estimates[0].institutional_info.institutional_fee.total_cost.human_readable;
        }
        else {
          this.providerPricing = "$0.00";
        }
      },
      (error) => {
        this.loaderService.hide();
        this.providerPricing = "$0.00";
        this.utils.showMessageSnackBar(error.error.error, true);
        console.error(error);
      }
    );
  }

}
